import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "./auth";

/**
 * Redireciona para /login se não autenticado e para /403 se não for admin.
 * Aguarda loadingAuth para não redirecionar durante a hidratação do Firebase.
 */
export default function useAdminGuard(): void {
  const { user, loadingAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loadingAuth) return;
    if (!user?.uid) {
      navigate("/login");
      return;
    }
    if (user.type !== "admin" && !user.isAdmin) {
      navigate("/403");
    }
  }, [user, loadingAuth, navigate]);
}
